import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ChangeTaskPage from './pages/ChangeTaskPage';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/add" element={<ChangeTaskPage />} />
        <Route path="/edit/:taskId" element={<ChangeTaskPage />} />
      </Routes>
    </Router>
  );
}

export default App;
